import { PopUpPadrao } from "../../componentes-padrao/PopUpPadrao";
import $ from "jquery";
import dxScrollView from "devextreme/ui/scroll_view";

export class PopUpAtualizacao extends PopUpPadrao {
    constructor(title, description, image_url, link_url, link_label, variant) {
        super(
            {
                desabilitarBotaoConfirmar: true,
                desabilitarBotaoCancelar: true,
                width: "auto",
                scrollingEnabled: true,
            },
            "PopUpAtualizacao",
            "Aviso"
        );
        this.title = title !== undefined ? title : "";
        this.description = description !== undefined ? description : "";
        this.image_url = image_url !== undefined ? image_url : null;
        this.link_url = link_url !== undefined ? link_url : "";
        this.link_label = link_label !== undefined ? link_label : "";
        this.variant = variant !== undefined ? variant : "padrão";
    }

    getContentTemplate() {
        let quantiaMaximaDeCaracteresParaAlterarOPopUp = 900;
        let alturaMaximaDaImagem = this.description.length < quantiaMaximaDeCaracteresParaAlterarOPopUp ? 400 : 200;
        let larguraMaximaDaImagem = this.description.length < quantiaMaximaDeCaracteresParaAlterarOPopUp ? 100 : 50;
        const titleHtml = this.title ? `<h2 style="width:99%;word-wrap: break-word;color:black;font-weight:900;">${this.title}</h2>` : "";
        const descriptionHtml = this.description ? `<p style="word-wrap: break-word; width:99%;">${this.description.replace(/\n/g, "<br>")}</p>` : "";

        let linkHtml = "";
        if (!this.link_label) {
            linkHtml = this.link_url ? `<a href="${this.link_url}" target="_blank">Disponível em: ${this.link_url}</a>` : "";
        } else {
            linkHtml = this.link_url ? `<a href="${this.link_url}" target="_blank">${this.link_label}</a>` : "";
        }

        const imageHtml = this.image_url
            ? `<img src="${this.image_url}" style="margin: 0 auto; max-width: ${larguraMaximaDaImagem}%; max-height: ${alturaMaximaDaImagem}px; object-fit: fill; display: block; width: 100%;" />`
            : "";

        if (!imageHtml && !titleHtml && !descriptionHtml) {
            return $("");
        }

        const $content = $(`
            <div style="max-width:1000px; padding: 10px;max-height:100%;">
                <div class="dx-scrollview-content">
                    ${titleHtml}
                    ${descriptionHtml}
                    ${linkHtml}
                    ${imageHtml}
                </div>
            </div>
        `);

        setTimeout(() => {
            const scrollViewContainer = $content.get(0);
            new dxScrollView(scrollViewContainer, {
                height: "500px",
                width: "100%",
                direction: "vertical",
                showScrollbar: "onHover",
                scrollByContent: true,
                scrollByThumb: true,
                bounceEnabled: false,
            });

            const targetElement = document.querySelector('.dx-overlay-content.dx-popup-normal.dx-popup-draggable.dx-resizable');
            if (targetElement) {
                targetElement.style.height = "auto";
                targetElement.style.maxHeight = "600px";                 targetElement.style.display = "flex";
                targetElement.style.flexDirection = "column";
                targetElement.style.alignItems = "stretch";
            }

            const contentDiv = document.querySelector('body > div.dx-overlay.dx-popup.dx-widget.dx-visibility-change-handler > div > div > div.dx-popup-content');
            if (contentDiv) {
                contentDiv.style.removeProperty('height');
                contentDiv.style.maxHeight = "500px";             }
        }, 0);

        return $content;
    }
}
